import { ETU, FilterETUDto } from '../../store/ETU';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getETUs = (filters?: FilterETUDto) => {
  let url = `${process.env.REACT_APP_API_SERVER_URL}/expected-true-ups?`;
  const urlParams = new URLSearchParams();
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null) urlParams.append(key, value.toString());
    }

    if (urlParams) url += urlParams.toString();
  }

  return apiService.callExternalApi<ETU[]>({
    url,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const postETU = (data: ETU) => {
  return apiService.callExternalApi<ETU>({
    url: `${API_SERVER_URL}/expected-true-ups`,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data
  });
};

export const putETU = (data: ETU) => {
  return apiService.callExternalApi<ETU>({
    url: `${API_SERVER_URL}/expected-true-ups/${data.id}`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data
  });
};

export const deleteETU = (id: string) => {
  return apiService.callExternalApi<null>({
    url: `${API_SERVER_URL}/expected-true-ups/${id}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};
